

const menu = [
    {
        icon: "activity-round-fill",
        text: "Dashboard",
        link: "/dashboard",
        active: localStorage.getItem("permissions")?.includes("dashboard"),
    },
    {
        icon: "bag-fill",
        text: "Live Orders",
        link: "/live-orders",
        active: localStorage.getItem("permissions")?.includes("live_orders"),
    },

    {
        heading: "Store Management",
        active: localStorage.getItem("permissions")?.includes("store_categories")
            || localStorage.getItem("permissions")?.includes("stores"),
    },
    {
        icon: "tile-thumb-fill",
        text: "Stores",
        active: localStorage.getItem("permissions")?.includes("store_categories")
            || localStorage.getItem("permissions")?.includes("stores"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("store_categories"),
                text: "Store Categories",
                link: "/store-categories",
            },
            {
                active: localStorage.getItem("permissions")?.includes("stores"),
                text: "Stores",
                link: "/stores",
            },
        ],
    },

    {
        heading: "Inventory Management",
        active: localStorage.getItem("permissions")?.includes("item_categories")
            || localStorage.getItem("permissions")?.includes("items")
            || localStorage.getItem("permissions")?.includes("item_groups"),
    },
    {
        icon: "tile-thumb-fill",
        text: "Item Management",
        active: localStorage.getItem("permissions")?.includes("market_categories")
            || localStorage.getItem("permissions")?.includes("item_categories")
            || localStorage.getItem("permissions")?.includes("items")
            || localStorage.getItem("permissions")?.includes("item_groups"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("market_categories"),
                text: "Market Categories",
                link: "/market-categories",
            },
            {
                active: localStorage.getItem("permissions")?.includes("item_categories"),
                text: "Item Categories",
                link: "/item-categories",
            },
            {
                active: localStorage.getItem("permissions")?.includes("items"),
                text: "Items",
                link: "/items",
            },
            {
                active: localStorage.getItem("permissions")?.includes("item_groups"),
                text: "Item Groups",
                link: "/item-groups",
            },
        ],
    },
    {
        icon: "tile-thumb-fill",
        text: "Addons Management",
        active: localStorage.getItem("permissions")?.includes("addon_categories")
            || localStorage.getItem("permissions")?.includes("addons"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("addon_categories"),
                text: "Addon Categories",
                link: "/addon-categories",
            },
            {
                active: localStorage.getItem("permissions")?.includes("addons"),
                text: "Addons",
                link: "/addons",
            },
        ],
    },
    {
        heading: "Users Management",
        active: localStorage.getItem("permissions")?.includes("vendors")
            || localStorage.getItem("permissions")?.includes("customers")
            || localStorage.getItem("permissions")?.includes("delivery_partners")
            || localStorage.getItem("permissions")?.includes("all_users"),
    },
    {
        icon: "users-fill",
        text: "User Management",
        active: localStorage.getItem("permissions")?.includes("all_users")
            || localStorage.getItem("permissions")?.includes("customers")
            || localStorage.getItem("permissions")?.includes("delivery_partners")
            || localStorage.getItem("permissions")?.includes("vendors"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("all_users"),
                text: "All Users",
                link: "/all-users",
            },
            {
                active: localStorage.getItem("permissions")?.includes("vendors"),
                text: "Vendors",
                link: "/vendors",
            },
            {
                active: localStorage.getItem("permissions")?.includes("customers"),
                text: "Customers",
                link: "/customers",
            },
            {
                active: localStorage.getItem("permissions")?.includes("delivery_partners"),
                text: "Delivery Partners",
                link: "/delivery-partners",
            },
        ],
    },

    {
        heading: "Report Management",
        active: localStorage.getItem("permissions")?.includes("all_orders")
            || localStorage.getItem("permissions")?.includes("datewise_order")
            || localStorage.getItem("permissions")?.includes("store_payouts")
            || localStorage.getItem("permissions")?.includes("delivery_collection")
            || localStorage.getItem("permissions")?.includes("delivery_collection_logs"),
    },
    {
        icon: "cc-alt2-fill",
        text: "Reports",
        active: localStorage.getItem("permissions")?.includes("all_orders")
            || localStorage.getItem("permissions")?.includes("datewise_order")
            || localStorage.getItem("permissions")?.includes("store_payouts")
            || localStorage.getItem("permissions")?.includes("delivery_collection")
            || localStorage.getItem("permissions")?.includes("delivery_collection_logs"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("all_orders"),
                text: "Orders",
                link: "/all-orders",
            },
            {
                active: localStorage.getItem("permissions")?.includes("datewise_order"),
                text: "Datewise Orders",
                link: "/datewise-order",
            },
            {
                active: localStorage.getItem("permissions")?.includes("store_payouts"),
                text: "Store Payout Report",
                link: "/store-payouts",
            },
            {
                active: localStorage.getItem("permissions")?.includes("delivery_collection"),
                text: "Delivery Collection Report",
                link: "/delivery-collection",
            },
            {
                active: localStorage.getItem("permissions")?.includes("delivery_collection_logs"),
                text: "Delivery Collection Log Report",
                link: "/delivery-collection-logs",
            },
        ],
    },
    {
        heading: "Promotions Management",
        active: localStorage.getItem("permissions")?.includes("banners")
            || localStorage.getItem("permissions")?.includes("sliders")
            || localStorage.getItem("permissions")?.includes("coupons")
            || localStorage.getItem("permissions")?.includes("scratch_cards"),
    },

    {
        icon: "layers-fill",
        text: "Promotions Management",
        active: localStorage.getItem("permissions")?.includes("banners")
            || localStorage.getItem("permissions")?.includes("sliders")
            || localStorage.getItem("permissions")?.includes("coupons")
            || localStorage.getItem("permissions")?.includes("scratch_cards"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("banners"),
                text: "Banners",
                link: "/banners",
            },
            {
                active: localStorage.getItem("permissions")?.includes("sliders"),
                text: "Sliders",
                link: "/sliders",
            },
            {
                active: localStorage.getItem("permissions")?.includes("coupons"),
                text: "Coupons",
                link: "/coupons",
            },
            {
                active: localStorage.getItem("permissions")?.includes("scratch_cards"),
                text: "Scratch Cards",
                link: "/scratch-cards",
            },
        ],
    },
    {
        heading: "City & Permission Management",
        active: localStorage.getItem("permissions")?.includes("messages")
            || localStorage.getItem("permissions")?.includes("cities"),
    },
    {
        icon: "file-docs",
        text: "City Management",
        active: localStorage.getItem("permissions")?.includes("messages")
            || localStorage.getItem("permissions")?.includes("cities"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("cities"),
                text: "Cities",
                link: "/cities",
            },
            {
                active: localStorage.getItem("permissions")?.includes("messages"),
                text: "Messages",
                link: "/messages",
            },
        ],
    },
    {
        icon: "grid-alt-fill",
        text: "Permission Management",
        active: localStorage.getItem("permissions")?.includes("permissions"),
        subMenu: [
            {
                active: localStorage.getItem("permissions")?.includes("permissions"),
                text: "Permissions",
                link: "/permissions",
            },
        ],
    },
    // {
    //     active: localStorage.getItem("permissions")?.includes("settings"),
    //     icon: "opt-alt-fill",
    //     text: "Settings",
    //     link: "/settings",
    // },

    //for loading template components

    // {
    //     icon: "bag",
    //     text: "Template preview",
    //     link: "/preview",
    //     panel: true,
    //     newTab: true,
    //     subPanel: [
    //         {
    //             icon: "dashboard-fill",
    //             text: "Dashboard",
    //             link: "/ecommerce/index",
    //         },
    //         {
    //             icon: "bag-fill",
    //             text: "Orders",
    //             link: "/ecommerce/orders",
    //         },
    //         {
    //             icon: "package-fill",
    //             text: "Products",
    //             link: "/ecommerce/products",
    //         },
    //         {
    //             icon: "users-fill",
    //             text: "Customers",
    //             link: "/ecommerce/customer",
    //         },
    //         {
    //             icon: "chat-fill",
    //             text: "Support",
    //             link: "/ecommerce/support",
    //         },
    //         {
    //             icon: "opt-alt-fill",
    //             text: "Settings",
    //             link: "/ecommerce/settings",
    //         },
    //         {
    //             icon: "server-fill",
    //             text: "Integration",
    //             link: "/ecommerce/integration",
    //         },
    //     ],
    // },
];
export default menu;
